import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { znithMark } from "@/lib/images";
import { Picture } from "./Picture";
import { trackCtaClick } from "@/lib/analytics";

export function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const sentinel = document.getElementById("nav-scroll-sentinel");
    if (!sentinel || typeof IntersectionObserver === "undefined") return;
    const observer = new IntersectionObserver(
      ([entry]) => setScrolled(!entry?.isIntersecting),
      { threshold: 0 },
    );
    observer.observe(sentinel);
    return () => observer.disconnect();
  }, []);

  return (
    <header
      className={cn(
        "fixed inset-x-0 top-0 z-50 transition-all duration-500",
        scrolled
          ? "border-b border-border/50 bg-midnight/95 py-3"
          : "py-5",
      )}
    >
      <div className="container-narrow flex items-center justify-between">
        <a href="#top" className="flex items-center gap-3">
          {/* Logo símbolo invertido para aparecer claro sobre fundo midnight */}
          <Picture
            pic={znithMark}
            alt=""
            decorative
            sizes="37px"
            width={36}
            height={28}
            loading="eager"
            fetchPriority="high"
            className="h-7 w-auto"
          />
          <span className="flex items-baseline gap-2">
            <span className="text-xl font-extrabold tracking-[0.18em] text-ivory">
              ZNITH
            </span>
            <span className="hidden text-[10px] font-bold uppercase tracking-[0.22em] text-gold sm:inline">
              SPRINT CODE
            </span>
          </span>
        </a>
        <Button
          asChild
          size="sm"
          className="bg-gradient-gold text-primary-foreground hover:opacity-90"
        >
          <a
            href="#inscricao"
            onClick={() => trackCtaClick("navbar", "Quero meu Sprint Code")}
          >
            Quero meu Sprint Code
          </a>
        </Button>
      </div>
    </header>
  );
}
